import { Component } from '@angular/core';

import { ToolComponent } from '@ximple/igo2-common';
import { IgoMap } from '@ximple/igo2-geo';

import { MapState } from '../../map/map.state';

@ToolComponent({
  name: 'directions',
  title: 'igo.integration.tools.directions',
  icon: 'directions'
})
@Component({
  selector: 'igo-directions-tool',
  templateUrl: './directions-tool.component.html'
})
export class DirectionsToolComponent {
  get map(): IgoMap {
    return this.mapState.map;
  }

  constructor(private mapState: MapState) {}
}
